import { useRef } from "react";

export const useStopwatch = () => {
  const startTimeRef = useRef<number | null>(null);

  return {
    start: (): void => {
      startTimeRef.current = Date.now();
    },

    stop: (): number => {
      if (!startTimeRef.current) return 0;
      return Date.now() - startTimeRef.current;
    },

    elapsed: (): number => {
      if (!startTimeRef.current) return 0;
      return Date.now() - startTimeRef.current;
    },

    isRunning: (): boolean => {
      return startTimeRef.current !== null;
    },

    reset: (): void => {
      startTimeRef.current = null;
    }
  };
};
